import { Button, Offcanvas } from "react-bootstrap";
import { MapContainer, Pane } from 'react-leaflet'
import { BUFFER_PANE, BUFFER_PANE_Z_INDEX } from '../utilities/constants';
import { useEffect, useState, useRef } from "react";
import RemoteControl from "./map/remoteControl";
import Basemap from "./map/basemap";
import postal from 'postal'
import arrayUtilities from "../utilities/arrayUtilities";
import DataGeomtry from "./map/dataGeometry";
import DataPoint from "./map/dataPoint";
import useApi from '../utilities/useApi';
import ErrorModal from "./common/errorModal";
import Loading from "./common/loading";

export const ImportPreview = ({ user, organisationId, handleClose, handleImport, workflows, file }) => {
    const mapRef = useRef(null);
    const { api } = useApi()
    const [points, setPoints] = useState(null);
    const [lines, setLines] = useState(null);
    const [center, setCenter] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [errorModal, setErrorModal] = useState(null)

    const [zoom, setZoom] = useState(18);
    const containerStyle = {
        width: '100%',
        height: '100%'
    };

    const handlePreview = () => {
        setIsLoading(true)
        api.importDataPreview(
            organisationId,
            file,
            data => {
                if (!arrayUtilities.isNullOrEmpty(data.items)) {
                    setPoints(data.items)
                    setLines(arrayUtilities.distinct(data.items.filter(x => x.lineId !== null).map(x => x.lineId)))
                    setCenter({
                        lat: data.items[0].lat,
                        lng: data.items[0].lng
                    })
                    postal.publish({
                    channel: "map",
                    topic: "view.change",
                    data: {
                        lat: data.items[0].lat,
                        lng: data.items[0].lng,
                    }
                    })
                }
                setIsLoading(false)
            },
            error => {
                setErrorModal({
                    message: error.message
                })
                setIsLoading(false)
            }
        )
    }

    useEffect(() => {
        handlePreview()
    }, [])

    return (
        <>
            <Offcanvas show placement='end' scroll={ false } backdrop id="import-data-preview-dialog">
            <Offcanvas.Header className='border-bottom'>
                <Offcanvas.Title>Preview</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="d-flex flex-align-start flex-column h-100 w-100 ">
                    <div className="w-100 h-100 mb-auto overflow-y-auto">
                        <div className="map-container d-flex flex-column align-items-center h-100">
                            {isLoading
                            ? <div className="d-flex w-100 h-100 justify-content-center align-items-center"><Loading size="8" /></div>
                            : <MapContainer center={center} zoom={ zoom } style={ containerStyle } dragging={ true } maxZoom={ 25 } ref={ mapRef } zoomSnap={ 0.1 } zoomDelta={ 0.1 }>
                                <RemoteControl onZoomChange={ setZoom } />
                                <Basemap basemap={ 0 } zoom={ zoom } isDownloadingMapPackage={ false } maxZoom={ 25 } />
                                <Pane name={BUFFER_PANE} style={{ zIndex: BUFFER_PANE_Z_INDEX }} />
                                {!arrayUtilities.isNullOrEmpty(lines) && <> {lines.map((lineId, index) => <DataGeomtry isPreview index={index} organisationId={organisationId} key={`line-${lineId}`} user={ user} lineId={lineId} points={points} lines={lines} workflows={workflows} />)} </>}
                                {!arrayUtilities.isNullOrEmpty(points) && <> {points.map((point, index) => <DataPoint isPreview index={index} key={`point-${point.id}`} user={user} organisationId={organisationId} point={point} workflows={workflows}  />)} </>}
                            </MapContainer>}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-2 w-100 mt-2">
                        <Button size="sm" variant='secondary' onClick={ () => handleClose() }>Cancel</Button>
                        <Button size="sm" variant="primary" onClick={ () => handleImport() }>Import</Button>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
        { errorModal !== null && <ErrorModal error={errorModal} onDismiss={() => {setErrorModal(null); handleClose()}} /> }
        </>
    )
}